import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import updateAction from '../../updateAction';

import BackButton from '../../components/BackButton';
import Disclaimer from '../../components/Disclaimer';
import Label from '../../components/Label';
import RadioGroup from '../../components/RadioGroup';
import Button from '../../components/Button';
import StackForm from '../../components/StackForm';
import Title from '../../components/Title';

import { useGlobalData } from '../../../store';
import { getPrestamosConsumo } from '../../config';

const Card = props => {
  const { register, errors, handleSubmit } = useForm({
    mode: 'onBlur',
  });
  const { action, state } = useStateMachine(updateAction);
  const [loading, setLoading] = useState(false);
  const [fail, setFail] = useState(false);
  const { setGlobalData } = useGlobalData();

  useEffect(() => {
    // NOTE: Al entrar al paso 1 hay que borrar las ofertas obtenidas y la oferta seleccionada
    if (state?.data) {
      action({ offers: null, response: null });
      setGlobalData({ plazo: '-' });
    }
  }, []); // eslint-disable-line

  const onSubmit = data => {
    setLoading(true);

    const defaultData = {
      es_cliente: true,
      tipo_cuenta: ['tipo_cuenta-cc', 'tipo_cuenta-ca'],
    };

    getPrestamosConsumo({
      esCliente: defaultData.es_cliente,
      monto: state?.data?.monto,
      cuentas: 'AMBAS',
      tarjetas: 'AMBAS',
      moneda: state?.data?.moneda,
    })
      .then(response => {
        action({
          ...data,
          es_cliente: defaultData.es_cliente,
          tarjeta: data.tarjeta,
          tipo_cuenta: defaultData.tipo_cuenta,
          response,
        });

        props.history.push('/3');
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        setFail(true);
      });
  };

  return (
    <StackForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <Title>Para seguir queremos saber si ya sos cliente Itaú.</Title>

        {fail && (
          <Disclaimer
            message="Ocurrió un error."
            subline="Vuelve a intentarlo o comunicate al 1784."
          />
        )}

        <Label mb={10}>¿Qué tarjeta de crédito tenés?</Label>

        <RadioGroup
          checkbox
          type="pill"
          name="tarjeta"
          options={[
            {
              label: 'Visa',
              value: 'tarjeta-visa',
              id: 'tarjeta-visa',
            },
            {
              label: 'MasterCard',
              value: 'tarjeta-mastercard',
              id: 'tarjeta-mastercard',
            },
            { label: 'Ninguna', value: 'tarjeta-no', id: 'tarjeta-no', unique: true },
          ]}
          register={register({ required: 'Este campo es obligatorio.' })}
          error={errors.tarjeta}
          defaultChecked={state?.data?.tarjeta}
        />
      </div>

      <div className="form-actions">
        <Button block type="submit" id="pTC_confirmar_3" disabled={loading}>
          {loading ? 'cotizando…' : 'siguiente'}
        </Button>

        <BackButton />
      </div>
    </StackForm>
  );
};

export default withRouter(Card);
